module.exports = __webpack_public_path__ + "static/media/exit.b4cb9e11.svg";